/** @knipignore */
export const vendorTierMap: Record<string, string> = {
	INTRO: 'Intro Tier WOB',
	INTRO_BUDGET: 'Intro Tier WB',
};

export const transformVendorTier = (vendorTier: string) =>
	vendorTierMap[vendorTier] ?? vendorTier;
